import htmlToBlocks from './html-to-blocks';
export default function htmlToSingleBlock(string, config, uploadManager) {
  config.removeLineBreaks = true;
  let blocks = htmlToBlocks(string, config, uploadManager);
  let root = blocks.shift();
  root.set('text', `${root.get('text')} `);
  blocks.forEach(block => {
    block.set('text', `${block.get('text')} `);
    root.join(block);
  });
  return [root];
}